// src/components/institution/modals/GalleryModal.jsx
import React from 'react';
import { X, Image, Video, Calendar, Users } from 'lucide-react';

export const GalleryModal = ({ gallery, onClose, styling }) => {
  if (!gallery) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center rounded-t-xl">
          <h2 className="text-xl font-bold text-gray-900">{gallery.name}</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="h-5 w-5 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {gallery.description && (
            <p className="text-gray-700 mb-6">{gallery.description}</p>
          )}

          {/* Gallery Stats */}
          <div className="flex items-center gap-6 mb-6 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <Image className="h-4 w-4" />
              <span>{gallery.mediaItems?.length || 0} items</span>
            </div>
            {gallery.createdAt && (
              <div className="flex items-center gap-2">
                <Calendar className="h-4 w-4" />
                <span>Created {new Date(gallery.createdAt).toLocaleDateString()}</span>
              </div>
            )}
          </div>

          {/* Media Grid */}
          {gallery.mediaItems && gallery.mediaItems.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {gallery.mediaItems.map((item, index) => (
                <div key={index} className="aspect-w-1 aspect-h-1 bg-gray-200 rounded-lg overflow-hidden">
                  <img
                    src={item.url || item.src}
                    alt={item.title || item.name || `Gallery item ${index + 1}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <Image className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-600">No media items in this gallery yet.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};